import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import Button from 'atoms/button';
import {
  addPlaceholder,
  editPlaceholder,
  removeRange,
  setUnavailability,
} from 'store/reducers/singleUnavailability';
import { getOpenAndClosingHours } from 'util';

import { OverrideRanges } from './OverrideRanges';

export default function Overrides({ inSingleDayPanel }) {
  const dispatch = useDispatch();
  const { hours } = useSelector((state) => state.provider.locations[0]);
  const { unavailable } = useSelector((state) => state.inventory);
  const { unavailable: singleUnavailability, date: unavailabilityDate } =
    useSelector((state) => state.singleUnavailability);
  // This is responsible for the animation upon deletion
  const [itemsToAnimate, setItemsToAnimate] = useState([]);

  useEffect(() => {
    if (!inSingleDayPanel) {
      if (unavailable.length === 0) {
        addPlaceholderDate();
      } else {
        dispatch(
          setUnavailability({
            date: unavailabilityDate,
            unavailable,
            isEditingUnavailability: false,
          })
        );
      }
    }
  }, []);

  const onSelectDate = (date, uuid) => {
    const { start, end } = getOpenAndClosingHours(date, hours);
    const startStr = `${date}T${start}`;
    const endStr = `${date}T${end}`;

    dispatch(
      editPlaceholder({
        date,
        start: startStr,
        end: endStr,
        uuid,
      })
    );
  };

  const onSelectTime = ({ date, start, end, uuid }) => {
    const startStr = !start.includes('T') ? `${date}T${start}.000Z` : start;
    const endStr = !end.includes('T') ? `${date}T${end}.000Z` : end;

    dispatch(
      editPlaceholder({
        date,
        start: startStr,
        end: endStr,
        uuid,
      })
    );
  };

  const addPlaceholderDate = () => {
    dispatch(addPlaceholder({ date: inSingleDayPanel && unavailabilityDate }));
  };

  const onRemoveDate = (uuid, isPlaceholder) => {
    setItemsToAnimate([...itemsToAnimate, uuid]);
    setTimeout(() => {
      dispatch(removeRange({ uuid, isPlaceholder }));
      const remainingItems = itemsToAnimate.filter((el) => el !== uuid);
      setItemsToAnimate(remainingItems);
    }, 400);
  };

  return (
    <>
      {singleUnavailability.map(
        ({ start, end, uuid, isPlaceholder, date }, i) => (
          <div
            className={classNames(
              'flex-column mt-18 override',
              itemsToAnimate.includes(uuid) &&
                singleUnavailability.length > 1 &&
                'deleted-animation deleted-animation-origin-overrides'
            )}
            key={uuid || i}
          >
            <OverrideRanges
              inSingleDayPanel={inSingleDayPanel}
              isPlaceholder={isPlaceholder}
              start={start}
              end={end}
              uuid={uuid}
              date={date}
              onSelectDate={onSelectDate}
              onRemoveDate={onRemoveDate}
              onSelectTime={onSelectTime}
            />
          </div>
        )
      )}
      <Button
        size="small"
        className="w-fit mt-15"
        variant="white-outlined"
        onClick={addPlaceholderDate}
        text="+  Add unavailable block"
      />
    </>
  );
}
